import { useState, useEffect, useMemo } from "react";
import { HttpNoData, HttpData } from "../../../../Core";
import { Alert, Button, Col, Form, InputGroup, ListGroup, Row, Stack } from "react-bootstrap";
import { MdEdit } from "react-icons/md";
import { HiPlus } from "react-icons/hi";
import styles from './style.module.css';
import TypeModalCreate from "./TypeModalCreate";
import TypeModalEdit from "./TypeModalEdit";
import CategoryModalCreate from "./CategoryModalCreate";
import CategoryModalEdit from "./CategoryModalEdit";
import ProductModalCreate from "./ProductModalCreate";
import ProductModalEdit from "./ProductModalEdit";
import AdditionInOrderModalCreate from "./AdditionInOrderModalCreate";
import AdditionOrderModalEdit from "./AdditionInOrderModalEdit";
import ModalNdsEdit from "./ModalNdsEdit";
import { FaAngleDoubleUp, FaAngleDoubleDown } from "react-icons/fa";

export default function Main({ jwt }) {

    const [typeCategories, setTypeCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);

    const [additionsInOrder, setAdditionsInOrder] = useState([]);

    const [priceSettings, setPriceSettings] = useState([]);

    const [createClass, setCreateClass] = useState();
    const [editClass, setEditClass] = useState('');

    const [isNds, setIsNds] = useState(false);

    useEffect(() => {
        async function loadData() {
            const additionsResponse = await HttpNoData('/api/v1/calculateOrderCost/orders/additions', 'GET', jwt);
            const typesResponse = await HttpNoData('/api/v1/calculateOrderCost/typeProductCategories', 'GET', jwt);
            const categoriesResponse = await HttpNoData('/api/v1/calculateOrderCost/productCategories', 'GET', jwt);
            const productsResponse = await HttpNoData('/api/v1/calculateOrderCost/products', 'GET', jwt);
            const priceOnWeightResponse = await HttpNoData('/api/v1/calculateOrderCost/priceOnWeight', 'GET', jwt);

            const sortedAdditions = additionsResponse.data?.sort((a, b) => a.priority - b.priority) ?? [];
            const sortedTypes = typesResponse.data?.sort((a, b) => a.priority - b.priority) ?? [];
            const sortedCategories = categoriesResponse.data?.sort((a, b) => a.priority - b.priority) ?? [];
            const sortedProducts = productsResponse.data?.sort((a, b) => a.priority - b.priority) ?? [];

            const fixedTypes = await checkAndFixDuplicates(sortedTypes, (id, priority) =>
                `/api/v1/calculateOrderCost/typeProductCategories/priority/${id}/${priority}`
            );
            const fixedCategories = await checkAndFixDuplicates(sortedCategories, (id, priority) =>
                `/api/v1/calculateOrderCost/productCategories/priority/${id}/${priority}`
            );
            const fixedProducts = await checkAndFixDuplicates(sortedProducts, (id, priority) =>
                `/api/v1/calculateOrderCost/products/priority/${id}/${priority}`
            );
            const fixedAdditions = await checkAndFixDuplicates(sortedAdditions, (id, priority) =>
                `/api/v1/calculateOrderCost/orders/additions/priority/${id}/${priority}`
            );

            setAdditionsInOrder(fixedAdditions);
            setTypeCategories(fixedTypes);
            setCategories(fixedCategories);
            setProducts(fixedProducts);
            setPriceSettings(priceOnWeightResponse.data ?? []);
        }

        loadData();
    }, []);

    async function checkAndFixDuplicates(array, urlBuilder) {
        const duplicates = array.some((item, index) =>
            array.findIndex((x) => x.priority === item.priority) !== index
        );

        if (duplicates) {
            console.log("Найдены дубликаты");
            return await arrayFixPriority(array, urlBuilder);
        }
        return array;
    }

    const handlePriceNameChange = (id, newName) => {
        setPriceSettings(prev =>
            prev.map(item =>
                item.id === id ? { ...item, name: newName } : item
            )
        );
    };

    const handlePriceValueChange = (id, newValue) => {
        setPriceSettings(prev =>
            prev.map(item =>
                item.id === id
                    ? {
                        ...item,
                        price: {
                            ...item.price,
                            units: newValue
                        }
                    }
                    : item
            )
        );
    };

    const updatePrice = async () => {
        for (let i = 0; i < priceSettings.length; i++) {
            const priceOnWeightResponse = await HttpData(`/api/v1/calculateOrderCost/priceOnWeight/${priceSettings[i].id}`, 'PUT', jwt, { id: priceSettings[i].id, name: priceSettings[i].name, price: priceSettings[i].price.units });
            if (!priceOnWeightResponse.statusSuccessful) {
                alert(`Не получилось обновить: ${priceOnWeightResponse.error}`);
                return;
            }
        }
        alert('Успешно сохранено');
    };

    const updatePriority = async (index, vector) => {
        if ((index === 0 && vector === 'up') || (additionsInOrder.length - 1 === index && vector === 'down')) {
            return;
        }

        const currentItem = additionsInOrder[index];
        let targetIndex;

        if (vector === 'up') {
            targetIndex = index - 1;
        } else if (vector === 'down') {
            targetIndex = index + 1;
        } else {
            alert('Ты что удумал?');
            return;
        }

        const targetItem = additionsInOrder[targetIndex];
        try {
            const updateCurrent = await HttpNoData(
                `/api/v1/calculateOrderCost/orders/additions/priority/${currentItem.id}/${targetItem.priority}`,
                'PUT',
                jwt
            );

            const updateTarget = await HttpNoData(
                `/api/v1/calculateOrderCost/orders/additions/priority/${targetItem.id}/${currentItem.priority}`,
                'PUT',
                jwt
            );

            if (updateCurrent.statusSuccessful && updateTarget.statusSuccessful) {
                setAdditionsInOrder(prev => {
                    const newArray = [...prev];
                    newArray[index] = { ...newArray[index], priority: targetItem.priority };
                    newArray[targetIndex] = { ...newArray[targetIndex], priority: currentItem.priority };
                    return newArray.sort((a, b) => a.priority - b.priority);
                });
            } else {
                alert('Не удалось обновить приоритеты на сервере');
            }
        } catch (error) {
            console.error('Ошибка при обновлении приоритетов:', error);
            alert('Произошла ошибка при обновлении приоритетов');
        }
    }

    const updateProductCategoryPriority = async (index, vector) => {
        if ((index === 0 && vector === 'up') || (categories.length - 1 === index && vector === 'down')) {
            return;
        }

        const currentItem = categories[index];
        let targetIndex;

        if (vector === 'up') {
            targetIndex = index - 1;
        } else if (vector === 'down') {
            targetIndex = index + 1;
        } else {
            alert('Ты что удумал?');
            return;
        }

        const targetItem = categories[targetIndex];
        try {
            const updateCurrent = await HttpNoData(
                `/api/v1/calculateOrderCost/productCategories/priority/${currentItem.id}/${targetItem.priority}`,
                'PUT',
                jwt
            );

            const updateTarget = await HttpNoData(
                `/api/v1/calculateOrderCost/productCategories/priority/${targetItem.id}/${currentItem.priority}`,
                'PUT',
                jwt
            );

            if (updateCurrent.statusSuccessful && updateTarget.statusSuccessful) {
                setCategories(prev => {
                    const newArray = [...prev];
                    newArray[index] = { ...newArray[index], priority: targetItem.priority };
                    newArray[targetIndex] = { ...newArray[targetIndex], priority: currentItem.priority };
                    return newArray.sort((a, b) => a.priority - b.priority);
                });
            } else {
                alert('Не удалось обновить приоритеты на сервере');
            }
        } catch (error) {
            console.error('Ошибка при обновлении приоритетов:', error);
            alert('Произошла ошибка при обновлении приоритетов');
        }
    }


    const updateTypePriority = async (index, vector) => {
        if ((index === 0 && vector === 'up') || (typeCategories.length - 1 === index && vector === 'down')) {
            return;
        }

        const currentItem = typeCategories[index];
        let targetIndex;

        if (vector === 'up') {
            targetIndex = index - 1;
        } else if (vector === 'down') {
            targetIndex = index + 1;
        } else {
            alert('Ты что удумал?');
            return;
        }

        const targetItem = typeCategories[targetIndex];
        try {
            const updateCurrent = await HttpNoData(
                `/api/v1/calculateOrderCost/typeProductCategories/priority/${currentItem.id}/${targetItem.priority}`,
                'PUT',
                jwt
            );

            const updateTarget = await HttpNoData(
                `/api/v1/calculateOrderCost/typeProductCategories/priority/${targetItem.id}/${currentItem.priority}`,
                'PUT',
                jwt
            );

            if (updateCurrent.statusSuccessful && updateTarget.statusSuccessful) {
                setTypeCategories(prev => {
                    const newArray = [...prev];
                    newArray[index] = { ...newArray[index], priority: targetItem.priority };
                    newArray[targetIndex] = { ...newArray[targetIndex], priority: currentItem.priority };
                    return newArray.sort((a, b) => a.priority - b.priority);
                });
            } else {
                alert('Не удалось обновить приоритеты на сервере');
            }
        } catch (error) {
            console.error('Ошибка при обновлении приоритетов:', error);
            alert('Произошла ошибка при обновлении приоритетов');
        }
    }

    const arrayFixPriority = async (array, predicate) => {

        const temp = [...array.sort((a, b) => a.priority - b.priority).map((o, i) => {
            o.priority = i + 1;
            return o;
        })];

        for (let i = 0; i < temp.length; i++) {
            const element = temp[i];
            await HttpNoData(predicate(element.id, element.priority), 'PUT', jwt);
        }

        return temp;
    }


    const updateProductPriority = async (index, vector) => {
        if ((index === 0 && vector === 'up') || (products.length - 1 === index && vector === 'down')) {
            return;
        }

        const currentItem = products[index];
        let targetIndex;

        if (vector === 'up') {
            targetIndex = index - 1;
        } else if (vector === 'down') {
            targetIndex = index + 1;
        } else {
            alert('Ты что удумал?');
            return;
        }

        const targetItem = products[targetIndex];
        try {
            const updateCurrent = await HttpNoData(
                `/api/v1/calculateOrderCost/products/priority/${currentItem.id}/${targetItem.priority}`,
                'PUT',
                jwt
            );

            const updateTarget = await HttpNoData(
                `/api/v1/calculateOrderCost/products/priority/${targetItem.id}/${currentItem.priority}`,
                'PUT',
                jwt
            );

            if (updateCurrent.statusSuccessful && updateTarget.statusSuccessful) {
                setProducts(prev => {
                    const newArray = [...prev];
                    newArray[index] = { ...newArray[index], priority: targetItem.priority };
                    newArray[targetIndex] = { ...newArray[targetIndex], priority: currentItem.priority };
                    return newArray.sort((a, b) => a.priority - b.priority);
                });
            } else {
                alert('Не удалось обновить приоритеты на сервере');
            }
        } catch (error) {
            console.error('Ошибка при обновлении приоритетов:', error);
            alert('Произошла ошибка при обновлении приоритетов');
        }
    }

    const productsByCategory = useMemo(() => {
        const grouped = {};
        categories.forEach(category => {
            grouped[category.id] = products.filter(product => product.categoryId === category.id)
                .sort((a, b) => a.priority - b.priority);
        });
        return grouped;
    }, [categories, products]);

    const currentId = editClass.includes(':') ? +editClass.split(':')[1] : 0;

    return <Stack className={styles.bodyMain} gap={3}>
        <Row>
            <Col md={6}>
                <Stack gap={1}>
                    {priceSettings.map((price, index) => (
                        <div key={price.id}>
                            <InputGroup className="mb-3">
                                <Form.Control
                                    type="text"
                                    value={priceSettings[index].name}
                                    onChange={(e) => handlePriceNameChange(price.id, e.target.value)}
                                    style={{ flex: 3 }}
                                />
                                <Form.Control
                                    type="number"
                                    value={priceSettings[index].price.units}
                                    onChange={(e) => handlePriceValueChange(price.id, e.target.value)}
                                    style={{ flex: 1 }}
                                />
                            </InputGroup>
                        </div>
                    ))}
                    <div className="d-flex justify-content-between">
                        <Button variant="success" onClick={() => setIsNds(true)}>НДС %</Button>
                        <Button
                            variant="success"
                            onClick={() => updatePrice()}
                        >
                            Сохранить
                        </Button>

                    </div>
                    {
                        isNds ? <ModalNdsEdit show={isNds} onHide={() => setIsNds(false)} jwt={jwt} /> : ''
                    }
                </Stack>
            </Col>
        </Row>
        <Row>
            <Col md>
                <h4>Типы</h4>
                <ListGroup>
                    {
                        typeCategories.length > 0 ?
                            typeCategories.map((o, index) => <ListGroup.Item key={o.id}>
                                <div className={styles.listItem}>
                                    <span>{o.name}</span>
                                    <Stack direction="horizontal" gap={1}>
                                        <Button variant="success" disabled={index == 0} onClick={() => updateTypePriority(index, 'up')}>
                                            <FaAngleDoubleUp />
                                        </Button>
                                        <Button variant="danger" disabled={index == typeCategories.length - 1} onClick={() => updateTypePriority(index, 'down')}>
                                            <FaAngleDoubleDown />
                                        </Button>
                                        <Button variant="warning" onClick={() => setEditClass(`type:${o.id}`)}>
                                            <MdEdit />
                                        </Button>
                                    </Stack>
                                </div>
                            </ListGroup.Item>)
                            : <Alert variant="warning">Пусто</Alert>
                    }
                    <Button variant="success" onClick={() => setCreateClass('type')}>
                        <HiPlus />
                    </Button>
                </ListGroup>
            </Col>
            <Col md>
                <h4>Дополнения к заказу</h4>
                <ListGroup>
                    {
                        additionsInOrder.length > 0 ?
                            additionsInOrder.map((o, index) => <ListGroup.Item key={o.id}>
                                <div className={styles.listItem}>
                                    <span>{o.name}</span>
                                    <Stack direction="horizontal" gap={1}>
                                        <Button variant="success" disabled={index == 0} onClick={() => updatePriority(index, 'up')}>
                                            <FaAngleDoubleUp />
                                        </Button>
                                        <Button variant="danger" disabled={index == additionsInOrder.length - 1} onClick={() => updatePriority(index, 'down')}>
                                            <FaAngleDoubleDown />
                                        </Button>
                                        <Button variant="warning" onClick={() => setEditClass(`addition:${o.id}`)}>
                                            <MdEdit />
                                        </Button>
                                    </Stack>

                                </div>
                            </ListGroup.Item>)
                            : <Alert variant="warning">Пусто</Alert>
                    }
                    <Button variant="success" onClick={() => setCreateClass('addition')}>
                        <HiPlus />
                    </Button>
                </ListGroup>
            </Col>
        </Row>

        <Row>
            <Col>
                <h4>Категории и продукция</h4>
                <Row>
                    {categories.map((category, catIndex) => (
                        <Col md={6} key={category.id} className="mb-3">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6 className="mb-0">{category.name}</h6>
                                    <Stack direction="horizontal" gap={1}>
                                        <Button
                                            variant="success"
                                            disabled={catIndex == 0}
                                            onClick={() => updateProductCategoryPriority(catIndex, 'up')}
                                            title="Поднять выше"
                                        >
                                            <FaAngleDoubleUp />
                                        </Button>
                                        <Button
                                            variant="danger"
                                            disabled={catIndex == categories.length - 1}
                                            onClick={() => updateProductCategoryPriority(catIndex, 'down')}
                                            title="Опустить ниже"
                                        >
                                            <FaAngleDoubleDown />
                                        </Button>
                                        <Button
                                            variant="warning"
                                            onClick={() => setEditClass(`category:${category.id}`)}
                                            title="Редактировать категорию"
                                        >
                                            <MdEdit />
                                        </Button>
                                        <Button
                                            variant="primary"
                                            onClick={() => setCreateClass(`product:${category.id}`)}
                                            title="Добавить продукт в эту категорию"
                                        >
                                            <HiPlus />
                                        </Button>
                                    </Stack>
                                </div>

                                <ListGroup>
                                    {productsByCategory[category.id]?.length > 0 ? (
                                        productsByCategory[category.id].map((product, prodIndex) => {
                                            const globalIndex = products.findIndex(p => p.id === product.id);
                                            return (
                                                <ListGroup.Item key={product.id}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="small">{product.name}</span>
                                                        <Stack direction="horizontal" gap={1}>
                                                            <Button
                                                                variant="success"
                                                                disabled={globalIndex == 0}
                                                                onClick={() => updateProductPriority(globalIndex, 'up')}
                                                                title="Поднять выше"
                                                            >
                                                                <FaAngleDoubleUp />
                                                            </Button>
                                                            <Button
                                                                variant="danger"
                                                                disabled={globalIndex == products.length - 1}
                                                                onClick={() => updateProductPriority(globalIndex, 'down')}
                                                                title="Опустить ниже"
                                                            >
                                                                <FaAngleDoubleDown />
                                                            </Button>
                                                            <Button
                                                                variant="warning"
                                                                onClick={() => setEditClass(`product:${product.id}`)}
                                                                title="Редактировать продукт"
                                                            >
                                                                <MdEdit />
                                                            </Button>
                                                        </Stack>
                                                    </div>
                                                </ListGroup.Item>
                                            );
                                        })
                                    ) : (
                                        <Alert variant="info" className="small mb-0 py-1">В этой категории нет продуктов</Alert>
                                    )}
                                </ListGroup>
                            </div>
                        </Col>
                    ))}
                </Row>

                <div className="mt-3">
                    <Button variant="success" onClick={() => setCreateClass('category')}>
                        <HiPlus /> Добавить новую категорию
                    </Button>
                </div>
            </Col>
        </Row>
        {
            createClass == 'type' ?
                <TypeModalCreate show={createClass == 'type'}
                    onCreated={c => setTypeCategories([...typeCategories, c])}
                    onHide={() => setCreateClass()}
                    jwt={jwt}
                /> : ''
        }
        {
            createClass == 'category' ?
                <CategoryModalCreate show={createClass == 'category'}
                    onCreated={c => setCategories([...categories, c])}
                    onHide={() => setCreateClass()}
                    types={typeCategories}
                    jwt={jwt}
                /> : ''
        }
        {
            createClass?.startsWith('product:') ?
                <ProductModalCreate
                    show={true}
                    onCreated={c => setProducts([...products, c])}
                    onHide={() => setCreateClass()}
                    categories={categories}
                    preselectedCategoryId={+createClass.split(':')[1]}
                    jwt={jwt}
                /> : ''
        }
        {
            createClass == 'addition' ?
                <AdditionInOrderModalCreate show={createClass == 'addition'}
                    onCreated={c => setAdditionsInOrder([...additionsInOrder, c])}
                    onHide={() => setCreateClass()}
                    jwt={jwt}
                /> : ''
        }



        {
            editClass.includes('type') ?
                <TypeModalEdit
                    show={true}
                    jwt={jwt}
                    onDeleted={() => setTypeCategories([...typeCategories.filter(f => f.id != currentId)]) || setEditClass('')}
                    onHide={() => setEditClass('')}
                    onUpdated={(u) => {
                        const index = typeCategories.findIndex(f => f.id == currentId)
                        typeCategories[index] = u;
                        setTypeCategories([...typeCategories])
                    }}
                    type={typeCategories.find(f => f.id == currentId)}
                /> : ''
        }
        {
            editClass.includes('category') ?
                <CategoryModalEdit
                    show={true}
                    jwt={jwt}
                    types={typeCategories}
                    onDeleted={() => setCategories([...categories.filter(f => f.id != currentId)]) || setEditClass('')}
                    onHide={() => setEditClass('')}
                    onUpdated={(u) => {
                        const index = categories.findIndex(f => f.id == currentId)
                        categories[index] = u;
                        setCategories([...categories])
                    }}
                    category={categories.find(f => f.id == currentId)}
                /> : ''
        }
        {
            editClass.includes('product') ?
                <ProductModalEdit
                    show={true}
                    jwt={jwt}
                    categories={categories}
                    onDeleted={() => setProducts([...products.filter(f => f.id != currentId)]) || setEditClass('')}
                    onHide={() => setEditClass('')}
                    onUpdated={(u) => {
                        const index = products.findIndex(f => f.id == currentId)
                        products[index] = u;
                        setProducts([...products])
                    }}
                    product={products.find(f => f.id == currentId)}
                /> : ''
        }
        {
            editClass.includes('addition') ?
                <AdditionOrderModalEdit
                    show={true}
                    jwt={jwt}
                    onDeleted={() => setAdditionsInOrder([...additionsInOrder.filter(f => f.id != currentId)]) || setEditClass('')}
                    onHide={() => setEditClass('')}
                    onUpdated={(u) => {
                        const index = additionsInOrder.findIndex(f => f.id == currentId)
                        additionsInOrder[index] = u;
                        setAdditionsInOrder([...additionsInOrder])
                    }}
                    addition={additionsInOrder.find(f => f.id == currentId)}
                /> : ''
        }

    </Stack >
}